<template>
  <div class="black_box dis_f fle_t">
          <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click="$store.commit('setAudioPlay',false)"
        alt
      >
      <img
        src="@/assets/img/audio_close.png"
        @click="$store.commit('setAudioPlay',true)"
        v-else
        class="contro_audio right"
        alt
      >
    <div class="w100">
      <img src="@/assets/img/com_txt.png" class="logo_txt" alt>
      <img src="@/assets/img/one_txt.png" class="one_txt" alt>
    </div>
    <div class="por">
      <van-swipe ref="banner" @change="changeTag" :show-indicators="false" :autoplay="0">
        <van-swipe-item>
          <img src="@/assets/img/Travel_one.png" class="travel_img" @click="bannerChange(0)" alt>
          <img src="@/assets/img/test_checked.png" v-show="testData[0]==0" class="checked_tag" alt>
        </van-swipe-item>
        <van-swipe-item>
          <img src="@/assets/img/Travel_two.png" class="travel_img" @click="bannerChange(1)" alt>
          <img src="@/assets/img/test_checked.png" v-show="testData[0]==1" class="checked_tag" alt>
        </van-swipe-item>
        <van-swipe-item>
          <img src="@/assets/img/Travel_three.png" class="travel_img" @click="bannerChange(2)" alt>
          <img src="@/assets/img/test_checked.png" v-show="testData[0]==2" class="checked_tag" alt>
        </van-swipe-item>
      </van-swipe>
      <img src="@/assets/img/throw_right.gif" @click="nextImg" class="btn_right" alt>
    </div>
    <div class="fl1"></div>
    <img src="@/assets/img/next_btn.png" data-name="1下一题" @click="openPage" class="test_btn" alt>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      bannerTag: 0
    };
  },
  computed: {
    ...mapState(["testData"])
  },
  methods: {
    bannerChange(num) {
      const data = JSON.parse(JSON.stringify(this.$store.state.testData));
      data[0] = num;
      this.$store.commit("setStoreData", {
        name: "testData",
        data: data
      });
    },
    openPage() {
      if (typeof this.testData[0] == "undefined") {
        this.$toast("请选择选项");
        return;
      }
      this.$router.replace("two");
    },
    nextImg() {
      let num = this.bannerTag + 1;
      num == 3 && (num = 0);
      this.$refs.banner.swipeTo(num);
    },
    changeTag(num) {
      this.bannerTag = num;
    }
  }
};
</script>

<style lang="scss" scoped>
.one_txt {
  width: 636px;
  margin-left: 30px;
  margin-top: 30px;
}
.travel_img {
  width: 100%;
}
.btn_right {
  width: 137px;
  position: absolute;
  right: 13px;
  bottom: 152px;
}
.checked_tag {
  width: 114px;
  position: absolute;
  left: 17px;
  top: 94px;
  z-index: 10;
}
</style>
